import React, { useState, useRef, useEffect } from 'react';
import { Tooltip } from 'antd';

interface TooltipIfOverflowProps {
    text: string;
    width?: number | string; // 可以接受数字(px)或字符串(如 '100%', '200px')
}

const TooltipIfOverflow: React.FC<TooltipIfOverflowProps> = ({ text, width = 300 }) => {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const textElementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (textElementRef.current) {
            const isOverflow =
                textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
            setIsOverflowed(isOverflow);
        }
    }, [text]);

    // 处理宽度，如果是数字则添加px单位
    const styleWidth = typeof width === 'number' ? `${width}px` : width;

    const content = (
        <div
            ref={textElementRef}
            style={{
                maxWidth: styleWidth,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }}
        >
            {text}
        </div>
    );

    return isOverflowed ? (
        <Tooltip
            title={text}
            destroyOnHidden={true}
            placement="topLeft"
            styles={{ body: { background: "white", borderRadius: "6px" },root:{ maxWidth: styleWidth} }}
        >
            {content}
        </Tooltip>
    ) : content;
};

export default TooltipIfOverflow;